// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {User} from '../../core/_models'
import {useNavigate} from 'react-router-dom'

type Props = {
  row: Row<User>
}

const CustomRow: FC<Props> = ({row}) => {

  const navigate = useNavigate()

  return <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          // onClick={()=>{
          //   if (cell.column.id === 'actions') return
          //
          //   navigate('/patient/' + row.original.id)
          // }}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
}

export {CustomRow}
